
import ko from 'rgs-knockout';

const Model = require('./js/model');
const template = require('./templates/control.html');


ko.components.register('person-identity-document-editor', {
	viewModel: Model,
	template: template(),
});